import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { iconsModule } from './modules/icons';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { autheliaAuthApi, customSignInPage } from './auth';
import {
  argoTerminalPlugin,
  kubeSecretsPlugin,
  projectNamePickerModule,
  appProjectFormModule,
  projectDeleteFormModule,
  catalogIndexModule,
  appTypeModulesModule,
  taskProjectBannerModule,
  createPageModule,
  scaffolderReactTranslationModule,
  tasksPlugin,
  costsPagePlugin,
  projectCostsModule,
  projectCostsTranslationModule,
  homePlugin,
  homeTranslationModule,
  projectEnvironmentsModule,
  branchPagePlugin,
  projectEnvironmentsTranslationModule,
  kubernetesContentFilterModule,
  projectKubernetesModule,
  projectKubernetesTranslationModule,
} from '@internal/plugin-waadoo-core';
import { odooProjectFormModule, odooAppModule } from '@internal/plugin-odoo';
import {
  catalogEntityTabsModule,
  pageLayoutModule,
  tabRowScrollModule,
  techdocsEntityTabsModule,
  userSettingsTabsModule,
  visualizerTabsModule,
} from './modules/tabs';
import { i18nModule } from '@waadoo/backstage-i18n';
import { lightTheme, darkTheme } from './themes';
import { DARK_THEME_ID, LIGHT_THEME_ID } from './theme/themeIds';
import './styles.css'; // Backstage UI (BUI) theme

// Exporté pour App.test.tsx, qui rend l'application sans sa page de connexion.
export const autheliaAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [autheliaAuthApi, customSignInPage],
});

const lightThemeExtension = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: LIGHT_THEME_ID,
      title: 'Light theme',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={lightTheme} children={children} />
      ),
    },
  },
});

const darkThemeExtension = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: DARK_THEME_ID,
      title: 'Dark theme',
      variant: 'dark',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={darkTheme} children={children} />
      ),
    },
  },
});

const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightThemeExtension, darkThemeExtension],
});

/**
 * Les fonctionnalités de l'application, exportées pour App.test.tsx : il
 * vérifie que le registre des modules de type d'application y trouve le
 * module Odoo (un module non enregistré ne fait rien, sans erreur).
 */
export const appFeatures = [
  homePlugin,
  homeTranslationModule,
  catalogPlugin,
  catalogIndexModule,
  navModule,
  iconsModule,
  appTypeModulesModule,
  odooAppModule,
  autheliaAuthModule,
  argoTerminalPlugin,
  kubeSecretsPlugin,
  projectEnvironmentsModule,
  projectEnvironmentsTranslationModule,
  branchPagePlugin,
  projectKubernetesModule,
  projectKubernetesTranslationModule,
  kubernetesContentFilterModule,
  projectNamePickerModule,
  appProjectFormModule,
  odooProjectFormModule,
  projectDeleteFormModule,
  taskProjectBannerModule,
  createPageModule,
  scaffolderReactTranslationModule,
  pageLayoutModule,
  tabRowScrollModule,
  userSettingsTabsModule,
  visualizerTabsModule,
  catalogEntityTabsModule,
  techdocsEntityTabsModule,
  tasksPlugin,
  projectCostsModule,
  projectCostsTranslationModule,
  costsPagePlugin,
  i18nModule,
  themeModule,
];

export default createApp({ features: appFeatures });
